<template>
  <div v-if="isOn()" data-component-group="alerts" data-component="cpmReports">
    <alerts-base
      type="info"
    >
      <template v-slot:text>
        <span class="bold">{{ $t('please_note') }} </span>
        <span>{{ $t('free_impressions_disclaimer_cpc_reports_page') }}</span>
      </template>
    </alerts-base>
  </div>
</template>

<script>
  export default {
    computed: {
      activeUser() {
        return this.$store.getters['auth/user'];
      },
    },
    methods: {
      isOn() {
        return this.activeUser?.business?.has_cpm_impressions;
      },
    },
  };
</script>

<style lang="scss">
[data-component-group='alerts'][data-component='cpmReports'] {
  .v-alert {
    margin-bottom: 16px;
    font-size: 15px;
    user-select: none;

    .v-icon {
      margin: auto 15px auto 10px;
    }
  }
}
</style>
